import * as React from 'react';
/**
 * @ignore - internal component.
 */

var ListContext = React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ListContext.displayName = 'ListContext';
}

export default ListContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/List/ListContext.js
// module id = 69
// module chunks = 0